import { Plane, TrainFront, BedDouble, Car, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { Reveal, staggerContainer, staggerItem } from "@/components/site/Reveal";

const ITEMS = [
  { icon: Plane, label: "Vuelos" },
  { icon: TrainFront, label: "Trenes" },
  { icon: BedDouble, label: "Hoteles" },
  { icon: Car, label: "Alquiler de coches" },
];

export default function TravelSection({ onCta }) {
  return (
    <section id="viajes" className="scroll-mt-24 py-20 sm:py-24" data-testid="travel-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal className="mb-4 text-center text-[13px] uppercase tracking-[0.12em] text-brand-gray">
          Servicio estrella
        </Reveal>
        <Reveal
          y={40}
          className="grid items-center gap-10 rounded-[18px] bg-brand-indigoDark p-8 sm:p-12 lg:grid-cols-[1.05fr_1fr] text-white"
        >
          <div>
            <h2 className="text-3xl sm:text-4xl font-medium leading-tight tracking-tight">
              Gestión completa de viajes
            </h2>
            <p className="mt-4 max-w-md text-[15px] leading-relaxed text-[#C7D2FE]">
              Dinos a dónde vas y nosotros hacemos el resto: buscamos, comparamos,
              reservamos y gestionamos cambios o cancelaciones. Tú solo recibes el
              itinerario listo en tu calendario.
            </p>
            <button
              data-testid="travel-cta"
              onClick={onCta}
              className="group mt-7 inline-flex items-center gap-2 rounded-[10px] bg-brand-mint px-6 py-3 text-[15px] font-medium text-[#04342C] hover:-translate-y-0.5 transition-transform duration-200"
            >
              Planifica tu próximo viaje
              <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" />
            </button>
          </div>

          <motion.div
            variants={staggerContainer}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-40px" }}
            className="grid grid-cols-2 gap-3.5"
          >
            {ITEMS.map(({ icon: Icon, label }) => (
              <motion.div
                key={label}
                variants={staggerItem}
                className="rounded-[14px] border border-white/15 bg-white/[0.06] p-5 backdrop-blur-sm transition-colors duration-200 hover:bg-white/[0.1]"
                data-testid={`travel-item-${label.toLowerCase().replace(/\s/g, "-")}`}
              >
                <Icon size={24} className="text-brand-mint" strokeWidth={1.75} />
                <p className="mt-3 text-[14px] font-medium">{label}</p>
              </motion.div>
            ))}
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
